import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  OutlinedInput,
  Select,
  Tooltip,
} from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import * as XLSX from "xlsx";
import useAdminData from "../../Queries/adminDataQuery";
import { useState, useCallback } from "react";
import useStateData from "../../Queries/stateDataQuery";
import { useBoundStore } from "useStore";

export default function ExportButton({ countryId }) {
  const stateDataQuery = useStateData({ countryId });
  const statusData = stateDataQuery.data ?? [];
  const options = [{ id: "all", nombre_estado: "Todos" }, ...statusData];

  const [openModal, setOpenModal] = useState(false);
  const selectedStatus = useBoundStore(
    (state) => state.soAdminSelectedStatusToExport,
  );
  const setSelectedStatus = useBoundStore(
    (state) => state.setSoAdminSelectedStatusToExport,
  );

  // Query deshabilitada por defecto: solo se ejecuta al hacer click en Exportar
  const exportQuery = useAdminData({
    countryId,
    fullData: true,
    stateOverride: selectedStatus?.id ?? "all",
    enabled: false,
  });

  const exportToExcel = (data, fileName) => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Datos");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);

  const handleExport = useCallback(async () => {
    const result = await exportQuery.refetch();
    if (result.data?.data?.length) {
      exportToExcel(
        result.data.data,
        `Devoluciones ${new Date().toISOString().slice(0, 10)}`,
      );
      handleClose();
    }
  }, [exportQuery, selectedStatus]);

  return (
    <>
      <Tooltip title="Exportar" placement="bottom" arrow>
        <span>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#002878",
              "&:hover": { backgroundColor: "#002878" },
            }}
            onClick={handleOpen}
            disabled={exportQuery.isFetching}
          >
            <FileDownloadOutlinedIcon sx={{ width: 30, height: 30 }} />
          </Button>
        </span>
      </Tooltip>
      <Dialog
        open={openModal}
        onClose={exportQuery.isFetching ? null : handleClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{ fontSize: "20px", fontWeight: 500, color: "#000000DE" }}
        >
          Selecciona el estado que quieres exportar
        </DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{ mt: 1 }}>
            <Select
              value={selectedStatus?.id ?? "all"}
              onChange={(event) => {
                const selected = options.find(
                  (opt) => opt.id === event.target.value,
                );
                setSelectedStatus(selected);
              }}
              displayEmpty
              input={<OutlinedInput />}
            >
              {options.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.nombre_estado}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="outlined"
            style={{
              color: "#002878",
              fontWeight: 500,
              borderColor: "#002878",
              "&:hover": { borderColor: "#002878" },
              width: "120px",
              textTransform: "uppercase",
            }}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleExport}
            variant="contained"
            disabled={exportQuery.isFetching}
            startIcon={
              exportQuery.isFetching ? (
                <CircularProgress size={16} />
              ) : undefined
            }
            style={{
              color: "white",
              fontWeight: 500,
              backgroundColor: "#002878",
              borderColor: "#002878",
              "&:hover": { borderColor: "#002878" },
              width: "160px",
              textTransform: "uppercase",
            }}
          >
            {exportQuery.isFetching ? "Exportando..." : "Exportar"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
